import 'core-js/es/set'
import 'core-js/es/map'
import 'react-app-polyfill/ie9';

import React from 'react';
import { createRoot } from 'react-dom/client'
import './index.css';

import App from './App';
import './i18n';

import * as serviceWorker from './serviceWorker';

const appContainer = document.getElementById('root');
const root = createRoot(appContainer);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
